"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clsx_1 = __importDefault(require("clsx"));
const TableHeader_1 = __importDefault(require("@Components/ViewWork/Table/TableHeader"));
const react_1 = __importDefault(require("react"));
const SubTable = ({ headerRow, rows }) => (react_1.default.createElement("div", { className: (0, clsx_1.default)('table', 'sub-table') },
    headerRow && react_1.default.createElement(TableHeader_1.default, { row: headerRow.row }),
    rows.map(({ cells }, index) => (react_1.default.createElement("div", { className: 'table-body table-row', key: `sub-row-${index}` }, cells.map((cell, idx) => (react_1.default.createElement("div", { className: 'table-cell', key: `sub-row-cell-${idx}` }, cell))))))));
exports.default = SubTable;
